import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("venmo",i`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            static
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4874_1112)">
                <mask
                    id="mask0_4874_1112"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24">
                    <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="#FCFCFC" />
                </mask>
                <g mask="url(#mask0_4874_1112)">
                    <path
                        d="M20.4 0H3.6C1.61177 0 0 1.61177 0 3.6V20.4C0 22.3882 1.61177 24 3.6 24H20.4C22.3882 24 24 22.3882 24 20.4V3.6C24 1.61177 22.3882 0 20.4 0Z"
                        fill="#3396CD" />
                    <path
                        d="M17.878 4.93555C18.3937 5.78398 18.6233 6.65586 18.6233 7.76211C18.6233 11.2824 15.6187 15.8574 13.1765 19.0684H7.60772L5.37646 5.70898L10.2562 5.24492L11.4421 14.7512C12.5437 12.9512 13.9077 10.1246 13.9077 8.20273C13.9077 7.14805 13.7249 6.43086 13.4437 5.84023L17.878 4.93555Z"
                        fill="white" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4874_1112">
                    <rect
                        width="24"
                        height="24"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as Venmo};
